export default __webpack_public_path__ + "1082eb3bf7be09cb7eea9fd3c057732e.ttf";